/** @format */
import BootstrapTable from "react-bootstrap-table-next";
import { Col } from "react-bootstrap";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  CSVExport,
  Search,
} from "react-bootstrap-table2-toolkit";
import { ReactComponent as ExportIcon } from "../assets/exportIcon.svg";
import { useDispatch, useSelector } from "react-redux";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import dayjs from "dayjs";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import React, { useEffect, useState } from "react";
import {
  deleteCalculator,
  getCalculator,
} from "../redux/actions/CalculatorAction";
import GetUser from "../services/get-user";
import { calculatorDataSelector } from "../redux/selectors/CalculatorSelectors";
import { CircularProgress } from "@material-ui/core";
import TableActionMenu from "./TableActionMenu";
import { ReactComponent as SearchIcon } from "../assets/searchIcon.svg";
import { apiToLocalObject } from "./Calculators/helper";
import {
  averagePerHour,
  calcHourly,
  profitMargin,
} from "./Calculators/Steps/calc";
import jsPDF from "jspdf";
import "jspdf-autotable";
import "../styling/table.css";

const headerColor = "#F8F8F8";

const CalculationTalble = ({
  stream,
  activeModalStep,
  handleCloseModal,
  setActiveModalStep,
}) => {
  const dispatch = useDispatch();
  const userData = GetUser();

  const calculatorData = useSelector(calculatorDataSelector);

  useEffect(() => {
    dispatch(getCalculator({ userID: userData.userID }));
  }, []);

  const [tableData, setTableData] = useState([]);
  const [fileName, setFileName] = useState("");
  const [openExportModal, setOpenExportModal] = useState(false);
  const [buttonType, setButtonType] = useState("");
  const { SearchBar, ClearSearchButton } = Search;
  const { ExportCSVButton } = CSVExport;

  const handleDelete = (id) => {
    const filterdData = tableData.filter((c: any) => c._id !== id);
    setTableData(filterdData);
    dispatch(deleteCalculator({ userID: userData.userID, calcID: id }));
  };

  const Actionformat = (cell, row) => {
    return (
      <div>
        <div className="dropdown-contaiewener" tabIndex={-1}>
          <TableActionMenu cell={cell} row={row} handleDelete={handleDelete} />
        </div>
      </div>
    );
  };
  const columns = [
    {
      dataField: "name",
      text: "Name",
      sort: true,
      headerClasses: "column-header first-field-header-space",
      formatter: (cell) => (
        <span className="first-field-cell-space">{cell}</span>
      ),
      headerStyle: {
        backgroundColor: headerColor,
        fontSize: "20px",
        color: "black",
        paddingBottom: 15,
        fontFamily: "ProximaNova-Semibold-11",
      },
      style: { fontWeight: 600, fontSize: 18 },
    },
    {
      dataField: "date",
      text: "Date",
      sort: true,
      headerClasses: "column-header",
      headerStyle: {
        backgroundColor: headerColor,
        fontSize: "20px",
        color: "black",
        paddingBottom: 15,
        fontFamily: "ProximaNova-Semibold-11",
      },
      style: { fontWeight: 500, fontSize: 18 },
    },
    {
      dataField: "detail",
      text: "Detail",
      headerClasses: "column-header non-sortable",
      headerStyle: {
        backgroundColor: headerColor,
        fontSize: "20px",
        color: "black",
        width: "40%",
        paddingBottom: 15,
        fontFamily: "ProximaNova-Semibold-11",
      },
      style: { fontSize: 18 },
      csvFormatter: (cell, row, rowIndex) => `${row.type}:$${row.profit}`
    },
    {
      dataField: "actions",
      text: "",
      csvExport: false,
      headerClasses: "column-header",
      headerStyle: {
        backgroundColor: headerColor,
        fontSize: "20px",
        color: "black",
        paddingBottom: 15,
        width: "15%",
        fontFamily: "ProximaNova-Semibold-11",
      },
      formatter: Actionformat,
    },
  ];

  const getOutputVal = (val) => {
    const obj = apiToLocalObject(val);
    switch (val.type) {
      case "Profit":
        return val.profit;
      case "Listing Price":
        return val.listing;
      case "Labor Value":
        const laborVal = calcHourly(obj, null, true);
        return laborVal?.lcost;
      case "Wage per Hour":
        const updateObj = averagePerHour(obj, null, true);
        return updateObj.averagePerHour;
      case "Profit Margin":
        const profitMarginVal = profitMargin(obj, null, true);
        return (
          <span>
            <span className="font-weight-bolder">Margin: </span>
            {profitMarginVal.netProfitMargin}%, &nbsp;
            <span className="font-weight-bolder"> Profit: </span>$
            {profitMarginVal.netProfit}
          </span>
        );
      default:
        return "Profit";
    }
  };

  const generatePDF = (data) => {
    const doc: any = new jsPDF("l", "mm", "a4");
    const title = "Calculation Pricing Report";
    const headers = [["Name", "Date","Details"]];

   const result=data.map((elt:any)=>{
    let calculationType=`${elt.type}:$${elt.profit}`
    return [elt.name,elt.date,calculationType]
   })   

    const content = {
      startY: 40,
      head: headers,
      body: result,
    };

    doc.text(title, 47,30,'center');
    doc.autoTable(content);
    doc.save(fileName !== "" ? `${fileName}.pdf` : "Calculation.pdf");
  };

  useEffect(() => {
    if (calculatorData.data?.length) {
      const data = calculatorData.data.map((val) => {
        return {
          ...val,
          date: dayjs(val.date).format("MMM DD YYYY"),
          detail: (
            <span>
              <span className="font-weight-bolder">
                {val.type === "Profit Margin" ? "" : `${val.type} :`}
              </span>{" "}
              {val.type === "Profit Margin" ? "" : "$"}
              {getOutputVal(val)}
            </span>
          ),
        };
      });
      setTableData(data);
    }
  }, [calculatorData.data]);

  const renderPageList = (options) => (
    <Col className="react-bootstrap-table-pagination-list" md={6}>
      <ul className="pagination react-bootstrap-table-page-btns-ul float-right">
        {options.pages.map((page) => (
          <li
            key={page.page}
            className={`${page.active ? "active-page" : ""}page-item ${page.disabled ? "disable-page" :""}`}
            onClick={() => options.onPageChange(page.page)}
          >
            <div className="page-link">
              {page.page}
            </div>
          </li>
        ))}
      </ul>
    </Col>
  );

  const pagination = paginationFactory({
    sizePerPage: 20,
    firstPageText: "<<",
    lastPageText: ">>",
    alwaysShowAllBtns: true,
    showTotal: true,
    pageListRenderer: renderPageList,
  });

  return (
    <div>
      <ToolkitProvider
        keyField="id"
        data={tableData}
        columns={columns}
        search
        exportCSV={{ fileName: `${fileName}.csv` }}
      >
        {(props) => (
          <>
            <div className="py-3">
              <span className="tabletitle"> Saved Calculations </span>
              <SearchIcon id="filtersubmit" className="mr-5" />
              <SearchBar {...props.searchProps} placeholder=" " />
              <ExportCSVButton
                className="export-button export-button-csv"
                onClick={() => {
                  setOpenExportModal(true);
                  setButtonType("CSV");
                  setFileName("");
                }}
              >
                <ExportIcon className="mr-2 mb-2 export-icon" />
                Export To CSV
              </ExportCSVButton>
              <button
                className="export-button btn btn-default export-button-pdf"
                onClick={() => {
                  setOpenExportModal(true);
                  setButtonType("PDF");
                  setFileName("");
                }}
              >
                <ExportIcon className="mr-2 mb-2 export-icon" />
                Export To PDF
              </button>
              <Dialog
                open={openExportModal}
                onClose={() => setOpenExportModal(false)}
                className="export-modal"
              >
                <DialogTitle className="pt-3 pb-0">
                  {buttonType === "CSV" ? "Export To CSV" : "Export To PDF"}
                </DialogTitle>
                <DialogContent>
                  <TextField
                    autoFocus
                    autoComplete="off"
                    value={fileName}
                    margin="dense"
                    id="name"
                    label="Enter File Name"
                    type="text"
                    fullWidth
                    variant="standard"
                    onChange={(e) => setFileName(e.target.value)}
                  />
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={() => setOpenExportModal(false)}
                    className="export-modal-button mb-2"
                  >
                    Cancel
                  </Button>
                  {buttonType === "CSV" ? (
                    <div
                      onClick={() => setOpenExportModal(false)}
                      className="export-modal-button mb-2 ml-3"
                    >
                      <ExportCSVButton {...props.csvProps}>
                        Export CSV{" "}
                      </ExportCSVButton>
                    </div>
                  ) : (
                    <Button
                      onClick={() => {
                        generatePDF(props.baseProps.data);
                        setOpenExportModal(false);
                      }}
                      className="export-modal-button mb-2"
                    >
                      Export PDF
                    </Button>
                  )}
                </DialogActions>
              </Dialog>
            </div>
            {calculatorData.loading ? (
              <div className="w-100 d-flex justify-content-center pb-5 pt-4">
                <CircularProgress style={{ color: "#48b7a7" }} />
              </div>
            ) : (
              <div id="calculationTalble">
                <BootstrapTable
                  bootstrap4
                  pagination={pagination}
                  filterPosition="top"
                  placement="top"
                  wrapperClasses="responsive"
                  rowClasses="table-hover"
                  bordered={false}
                  keyField="id"
                  {...props.baseProps}
                />
              </div>
            )}
          </>
        )}
      </ToolkitProvider>
    </div>
  );
};

export default CalculationTalble;
